import './Header.css'
import { change } from '../../feature/mode/modeSlice';
import { useDispatch, useSelector } from 'react-redux';

const Header = () => {

  const  mode = useSelector(state => state.mode.value)
  const dispatch = useDispatch()

    if(mode){
        return(
        <div id='header' className={mode ? 'header-dark-mode' : 'header-light-mode'}>
            <h2>Where in the world?</h2>
            <div className='mode' onClick={() => dispatch(change())}>
                <span class="material-symbols-outlined">
                    light_mode
                </span>
                <h5>Light Mode</h5>
            </div>
        </div>
        )
    }else{
        return(
        <div id='header' className={mode ? 'header-dark-mode' : 'header-light-mode'}>
        <h2>Where in the world?</h2>
        <div className='mode' onClick={() => dispatch(change())}>
            <span className="material-symbols-outlined">
                dark_mode
            </span>
            <h5>Dark Mode</h5>
        </div>
    </div>
        )
    }
}

export default Header